<template>
  <span>
    <span v-if="info">
      <span v-if="info.role !== ''" class="font-weight-bold">[{{ info.role }}] </span>
      <span class="">{{ info.email }}</span>
    </span>
    <slot v-else>
      User
    </slot>
  </span>
</template>

<script >
import Vue from 'vue'

export default Vue.extend({
  name: 'StaffUserLabel',
  props: {
    info: {
      type: Object,
      default: () => ({})
    }
  }
})
</script>

<style scoped>

</style>
